import { compose, filter, find, path, props, propOr, propEq, join, test } from 'ramda';
import translate from 'counterpart';
import moment from 'moment';
import { pathOr, contains, last } from 'ramda';

import { notEmpty } from 'utils/ramdaAdditions';
import { DATE_FORMATS } from 'constants/dateFormats';

export const intervalTemplate = (from, to, preFrom = translate('request.from'), preTo = translate('request.up_to'), empty = '') => {
    let result = '';
    if (from && to) {
        result += `${from} - ${to} `;
    } else {
        result += from ? `${preFrom} ${from} ` : '';
        result += to ? `${preTo} ${to} ` : '';
    }
    return result || empty;
};

const defaultFullNameOrder = ['lastName', 'firstName', 'middleName'];

export const getName = path([0, 'text']);
export const getId = path([0, 'id']);

export const getProjectName = pathOr('', ['posname', '0', 'text']);

export const getFullNameInOrder = (order = defaultFullNameOrder) => (
    compose(join(' '), filter(Boolean), props(order))
);

export const getFullName = getFullNameInOrder();

export const getValueFromDictBy = (dictFieldName, propName) => (value, dictionary, defaultValue = null) => (
    renderValueFromDictBy({
        defaultValue,
        propName,
        item: getItemFromDictBy(dictFieldName, value, dictionary)
    })
);
export const getItemFromDictBy = (dictFieldName, value, dictionary) => (
    find(propEq(dictFieldName, value), dictionary)
);
export const renderValueFromDictBy = ({ defaultValue = null, propName, item }) => (
    propOr(defaultValue, propName, item)
);

export const getDateTimeRange = (value, empty) => notEmpty(value) ? (
    value.from === value.to && value.from ? value.from : intervalTemplate(value.from, value.to, '', '', empty)
 ) : null;

export const toFormat = (time, parseFormat, renderFormat) => (
    time && moment(time, parseFormat).isValid() && (`${time}`.length === parseFormat.length) ? (
        moment(time, parseFormat).format(renderFormat)
    ) : undefined
);

export const momentToFormat = (date, format) => {
    return date.clone().format(format || DATE_FORMATS.dayMonthFormat);
};

export const getCurrentDate = () => {
    return moment().format(DATE_FORMATS.parse);
};

export const getValidLink = (link) => {
    if (test(/^https?:\/\//, link)) {
        return link;
    } else {
        return `http://${link}`;
    }
};

const handleDot = value => contains('.', last(`${value}`)) ? '.' : '';
const checkNumber = value => value && !isNaN(Number(value));
export const formatMoney = value => checkNumber(value) && `${Number(value)}${handleDot(value)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
export const formatIntervalMoney = value => value && checkNumber(value) && `${Number(value)}${handleDot(value)}`.replace(/(.)(?=(\d{3})+$)/g, '$1 ');

export const salaryIntervalTemplate = (min, max) => {
    return intervalTemplate(formatIntervalMoney(min), formatIntervalMoney(max));
};
